// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__aVSZc","label":"Completed_label__lpbP7"};